import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'com-form-group',
  templateUrl: './form-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormGroupComponent {}
